export function clampTime(value: number): number { return Number.isFinite(value) ? Math.max(0, value) : 0; }
export function formatClock(seconds: number, separator = ','): string {
  const ms = Math.round(clampTime(seconds) * 1000);
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  const s = Math.floor((ms % 60_000) / 1000);
  const remain = ms % 1000;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}${separator}${String(remain).padStart(3, '0')}`;
}
export function humanBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB']; let value = bytes / 1024; let i = 0;
  while (value >= 1024 && i < units.length - 1) { value /= 1024; i += 1; }
  return `${value.toFixed(value >= 10 ? 1 : 2)} ${units[i]}`;
}
export function humanDuration(seconds: number): string {
  if (!Number.isFinite(seconds)) return '—';
  const m = Math.floor(seconds / 60); const s = Math.round(seconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}
